export default __webpack_public_path__ + "static/media/line_bg_indicators.c1abdf2e.svg";